import React, { useMemo } from 'react';
import { SlidersHorizontal } from 'lucide-react';
import StatusCard from './StatusCard';
// import SectionHeader from './SectionHeader';
import { useDashboardStore } from '../../../stores/dashboard-store';
import { useLanguage } from '../../../contexts/LanguageContext';
import { CheckmarkIcon, OnItsWayIcon, PaymentUnverifiedIcon } from '../../../components/icons/DashboardIcons';

const FacilitySection: React.FC = () => {
  const { stats } = useDashboardStore();
  const { t } = useLanguage();

  const getStatusValue = (statusKey: string): string => {
    const value = stats?.status_counts?.[statusKey];
    return value !== undefined ? value.toString() : '0';
  };

  const facilityCards = useMemo(() => [
    {
      title: t('dashboard.notDelivered'),
      value: getStatusValue('procured-but-not-delivered-to-facility'),
      change: '+5%',
      changeType: 'increase' as const,
      icon: PaymentUnverifiedIcon,
      color: 'orange',
      navigateTo: '/operation?tab=in_facility&subStatus=in_bound'
    },
    {
      title: t('dashboard.delivered'),
      value: getStatusValue('delivered-to-facility'),
      change: '+50%',
      changeType: 'increase' as const,
      icon: CheckmarkIcon,
      color: 'green',
      navigateTo: '/operation?tab=in_facility&subStatus=in_facility'
    },
    {
      title: t('dashboard.shippedToWarehouse'),
      value: getStatusValue('shipped-to-destination-warehouse'),
      change: '+50%',
      changeType: 'increase' as const,
      icon: OnItsWayIcon,
      color: 'purple',
      navigateTo: '/operation?tab=destination_warehouse&subStatus=inbound'
    }
  ], [stats, t]);

  return (
    <div>
      {/* Section with background covering title and controls */}
      <div className="rounded-lg bg-[#F1F1F4] p-3 md:p-4">
        {/* Section Header with Monthly button */}
        <div className="mb-3 flex items-center justify-between">
          <h2 className="text-[35px] font-medium leading-none text-[#24304F]">{t('dashboard.facility')}</h2>
          <button className="inline-flex items-center gap-1.5 rounded-md bg-[#DFE3EC] px-3 py-1.5 text-[13px] font-medium text-[#5D6680]">
            <SlidersHorizontal size={14} />
            {t('common.month')}
          </button>
        </div>
        
        {/* Cards */}
        <div className="space-y-3">
          {facilityCards.map((card, index) => (
            <StatusCard key={index} card={card} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FacilitySection;